<template>
  <div>
    <v-bottom-sheet v-if="$vuetify.breakpoint.mdAndDown" v-model="visible" inset max-width="500" scrollable>
      <QuickAddToCart v-if="item" :value="item" @close="visible = false"/>
    </v-bottom-sheet>
    <v-navigation-drawer v-else v-model="visible" fixed right temporary width="550">
      <QuickAddToCart v-if="item" :value="item" @close="visible = false"/>
    </v-navigation-drawer>
  </div>
</template>

<script>
import QuickAddToCart from "@/components/catalogue/QuickAddToCart";

export default {
  name: "QuickPreview",
  components: { QuickAddToCart },
  data() {
    return {
      visible: false,
      item: null
    }
  },
  created() {
    this.$bus.$on('preview', this.show)
  },
  methods: {
    show(item) {
      this.item = item;
      this.visible = true;
    }
  },
  watch: {
    visible(v) {
      if (!v) this.item = null;
    }
  }
}
</script>
